import React, { Component, PropTypes } from 'react';
import styles from './SwitchLanguage.scss';
import CSSModules from 'react-css-modules';
import SwitchLanguageButtons from './SwitchLanguageButtons';


const SwitchLanguage = ({ handleChange, languages, currentLang }) => (
    <div styleName="footer">
        <div styleName="switch-language">
            <form>
                <fieldset>
                    <legend className="is-visuallyhidden">Switch language</legend>
                    <SwitchLanguageButtons
                        currentLang={currentLang}
                        languages={languages}
                        handleChange={handleChange}
                    />
                </fieldset>
            </form>
        </div>
    </div>
);

SwitchLanguage.propTypes = {
    handleChange: PropTypes.func.isRequired,
    languages: PropTypes.array.isRequired,
    currentLang: PropTypes.string.isRequired,
};

SwitchLanguageButtons.defaultProps = {
    languages: []
};

export default CSSModules(SwitchLanguage, styles);


// WEBPACK FOOTER //
// ./app/components/Main/SwitchLanguage/index.jsx